import type { ComponentType } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import Routers from "../constants/routers";
import { getToken } from "../utils/common/common";

export const notAuth = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const AuthenticatedComponent: React.FC<P> = (props) => {
    const isAuthenticated = getToken();

    if (!isAuthenticated) {
      return <WrappedComponent {...props} />;
    }
    return <Navigate to={Routers.Contracts} replace />;
  };

  return AuthenticatedComponent;
};

export const withAuth = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const AuthenticatedComponent: React.FC<P> = (props) => {
    const isAuthenticated = getToken();

    if (isAuthenticated) {
      return <WrappedComponent {...props} />;
    }
    return <Navigate to={Routers.Login} replace />;
  };

  return AuthenticatedComponent;
};

export function AuthGuard() {
  const location = useLocation();
  const isAuthenticated = !!getToken();

  if (!isAuthenticated) {
    return <Navigate to={Routers.Login} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
